module.exports = __webpack_public_path__ + "img/DW365-008.8b9cea78.jpg";